export enum ExchangeState {
    Agreed = 0,
    DoneWithDebt = 1,
    DoneWithDeposit = 2,
    Done = 99,
  }